const reduxObject = JSON.parse(localStorage.getItem("redux_object") || "{}");
const accessToken = reduxObject ? reduxObject.accessToken : null;

export const service = {
  loginTools: async (data) => {
    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "token-login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    );

    if (response.status === 401) {
      window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
      return;
    }

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || "Login fallito.");
    }

    return await response.json();
  },

  login: async (data) => {
    const response = await fetch(process.env.REACT_APP_API_ENDPOINT + "login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || "Login fallito.");
    }

    return await response.json();
  },

  logout: async (data) => {
    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "logout",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || "Logout fallito.");
    }

    return await response.json();
  },

  getPractice: async () => {
    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "get-practices-user",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || "Login fallito.");
    }

    return await response.json();
  },

  getPracticeAdmin: async () => {
    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "get-all-practices",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message || "Login fallito.");
    }

    return await response.json();
  },

  store: async (practice, team_id, user_id, step) => {
    const data = {
      practice: JSON.stringify(practice),
      team_id: team_id,
      user_id: user_id,
      step: step,
    };
    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "store-practice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  update: async (
    practice,
    practice_id,
    team_id,
    user_id,
    step,
    readers_email,
  ) => {
    const data = {
      practice: JSON.stringify(practice),
      practice_id: practice_id,
      team_id: team_id,
      user_id: user_id,
      step: step,
      readers_email: readers_email,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "update-practice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  updateAdmin: async (practice_id, note_admin) => {
    // salva pratica admin con note_admin
    const data = {
      practice_id: practice_id,
      worked: 0,
      note_admin: note_admin,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "set-worked-practice",
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  delete: async (practice_id) => {
    const data = {
      practice_id: practice_id,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "delete-practice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  deleteDocument: async (practice_id, file_id) => {
    const data = {
      practice_id: practice_id,
      file_id: file_id,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "delete-attachment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  deleteDocumentClient: async (practice_id, file_id) => {
    const data = {
      practice_id: practice_id,
      file_id: file_id,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "delete-attachment-new-customer",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  send: async (practice_id) => {
    const data = {
      practice_id: practice_id,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "send-practice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  workedPractice: async (practice_id, adminNotes, pdfGenerate) => {
    try {
      const formData = new FormData();
      formData.append("practice_id", practice_id);
      formData.append("worked", 1);
      formData.append("note_admin", adminNotes);
      formData.append(
        "file",
        pdfGenerate,
        `Riepilogo_pratica_${practice_id}.pdf`,
      );

      const reduxObject = JSON.parse(
        localStorage.getItem("redux_object") || "{}",
      );
      const accessToken = reduxObject ? reduxObject.accessToken : null;

      const response = await fetch(
        process.env.REACT_APP_API_ENDPOINT + "set-worked-practice",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + accessToken,
            Accept: "application/json",
            "Accept-Encoding": "multipart/form-data",
          },
          body: formData,
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Errore nella chiamata API");
      }

      return await response.json();
    } catch (error) {
      console.error("Errore in workedPractice:", error);
      throw error;
    }
  },

  sendPdfDailyReport: async (practice_id, pdfGenerateDailyReport) => {
    try {
      const formData = new FormData();
      formData.append("practice_id", practice_id);
      formData.append(
        "file",
        pdfGenerateDailyReport,
        `Riepilogo_pratica_${practice_id}.pdf`,
      );

      const reduxObject = JSON.parse(
        localStorage.getItem("redux_object") || "{}",
      );
      const accessToken = reduxObject ? reduxObject.accessToken : null;

      const response = await fetch(
        process.env.REACT_APP_API_ENDPOINT + "upload-daily-report",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + accessToken,
            Accept: "application/json",
            "Accept-Encoding": "multipart/form-data",
          },
          body: formData,
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Errore nella chiamata API");
      }

      return await response.json();
    } catch (error) {
      console.error("Errore", error);
      throw error;
    }
  },

  downloadFile: async (practice_id) => {
    const data = {
      practice_id: practice_id,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "download-file-practice",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  forgotPw: async (email) => {
    const data = {
      email: email,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    const response = await fetch(
      process.env.REACT_APP_API_ENDPOINT + "forgot-password",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify(data),
      },
    );

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.message);
    }

    return await response.json();
  },

  resetPw: async (email, password, password_confirmation, token) => {
    const data = {
      email: email,
      password: password,
      password_confirmation: password_confirmation,
      token: token,
    };

    const reduxObject = JSON.parse(
      localStorage.getItem("redux_object") || "{}",
    );
    const accessToken = reduxObject ? reduxObject.accessToken : null;

    try {
      const response = await fetch(
        process.env.REACT_APP_API_ENDPOINT + "reset-password",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Errore nella risposta:", errorData);
        throw new Error(errorData.message);
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
      throw error;
    }
  },
};
